import AddIcon from 'Component/AddIcon';
import Button from 'Component/Button';
import { SIZE_NONE, TYPE_TEXT, WIDTH_HUG } from 'Component/Button/Button.config';
import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM, TOP } from 'Component/ChevronIcon/ChevronIcon.config';
import { BLACK_KEY, M_KEY } from 'Component/Icon/Icon.config';
import MinusIcon from 'Component/MinusIcon';
import TextPlaceholder from 'Component/TextPlaceholder';
import {
    ExpandableContent as SourceExpandableContent
} from 'SourceComponent/ExpandableContent/ExpandableContent.component';

import './ExpandableContent.style';
/** @namespace Bodypwa/Component/ExpandableContent/Component */
export class ExpandableContentComponent extends SourceExpandableContent {
    /* eslint-disable */
    componentDidUpdate() {
        const { forceClose, currentExpanded, accordeon, device: { isMobile } } = this.props;

        if(forceClose) {
            this.setState({
                isContentExpanded: false
            });
        }
        if (accordeon && !isMobile) {
            const isContentExpanded = currentExpanded === this.expandableContentRef;
            this.setState({
                isContentExpanded
            });
        }
    }
    /* eslint-disable */

    static defaultProps = {
        heading: '',
        isContentExpanded: false,
        onClick: null,
        children: [],
        isArrow: false,
        mods: {},
        accordeon: false,
        closeExpanded: () => false,
        currentExpanded: null
    };

     renderButton() {
        const { isContentExpanded } = this.state;
        const { heading, mix } = this.props;

        return (
            <div
              role="button"
              tabIndex={ 0 }
              block="ExpandableContent"
              elem="Button"
              mods={ { isContentExpanded } }
              mix={ { ...mix, elem: 'ExpandableContentButton' } }
              onClick={ this.toggleExpand }
              onKeyDown={ this.toggleExpand }
            >
                <div
                  block="ExpandableContent"
                  elem="Heading"
                  mix={ { ...mix, elem: 'ExpandableContentHeading' } }
                >
                    { typeof heading === 'string' ? (
                        <TextPlaceholder content={ heading } length="mediumM" />
                    ) : (
                        heading
                    ) }
                   
                </div>
                {heading ? (
                    this.renderButtonIcon()
                ) : (
                    <TextPlaceholder length="mediumL" />
                )}
            </div>
        );
    }

    renderButtonIcon() {
        const { isContentExpanded } = this.state;
        const { isArrow } = this.props;

        if (isArrow) {
            
            return ( 
            <Button
                type={ TYPE_TEXT }
                isIcon
                size={ SIZE_NONE }
                width={ WIDTH_HUG }
             >
            <ChevronIcon color={ BLACK_KEY } size={ M_KEY } direction={ isContentExpanded ? TOP : BOTTOM } />
                    </Button>
            )
        }

        return this.renderTogglePlusMinus();
    }

    renderTogglePlusMinus() {
        const { isContentExpanded } = this.state;

        return  <Button
                    onClick={this.toggleContent}
                    type={ TYPE_TEXT }
                    width={ WIDTH_HUG }
                    isIcon
                    size={ SIZE_NONE }
                    >
                    {isContentExpanded ? (<MinusIcon size={ M_KEY } color={ BLACK_KEY } />) : (
                        <AddIcon size={ M_KEY } color={ BLACK_KEY } />
                    )}
                </Button>
        
    }

    toggleExpand = () => {
        const { onClick, closeExpanded } = this.props;
        if (onClick) {
            onClick();

            return;
        }

        closeExpanded(!this.state.isContentExpanded, this.expandableContentRef);
        this.setState(
            ({ isContentExpanded }) => ({ isContentExpanded: !isContentExpanded }),
            () => this.scrollToExpandedContent()
        );
    };
}

export default ExpandableContentComponent;
